<template>
    <div class="global_sidebar course-sidebar" :class="{ 'course-sidebar--dark': dark }">
        <header class="course-sidebar__header">
            <div class="course-sidebar__toolbar">
                <button
                    type="button"
                    class="course-sidebar__back"
                    @click="backPage()"
                >
                    <fa icon="arrow-left" class="course-sidebar__back-icon" />
                    <span>Voltar</span>
                </button>
                <button
                    v-show="largura < 768"
                    type="button"
                    class="course-sidebar__close"
                    aria-label="Fechar menu"
                    @click="storeShowSidebar({ showSidebar: !showSidebar })"
                >
                    <fa icon="fa-xmark" />
                </button>
            </div>

            <div class="course-sidebar__course">
                <h2 class="course-sidebar__title">
                    {{ currentCoursePortal?.course?.comercialName }}
                </h2>
                <div class="course-sidebar__progress">
                    <div class="course-sidebar__progress-track">
                        <div
                            class="course-sidebar__progress-fill"
                            :style="{ width: progressPercentUi + '%' }"
                        />
                    </div>
                    <span class="course-sidebar__progress-label">{{ progressPercentUi }}%</span>
                </div>
            </div>
        </header>

        <div class="course-sidebar__scroll">
            <v-expansion-panels
                class="course-sidebar-panels"
                variant="accordion"
                v-model="currentModuleOpenLocal"
            >
                <v-expansion-panel
                    v-for="(item, index) in data"
                    :key="index"
                    class="course-sidebar-panel"
                >
                    <v-expansion-panel-title
                        class="course-sidebar-panel__title"
                        expand-icon="mdi-menu-down"
                    >
                        <div class="course-sidebar-panel__head">
                            <span class="course-sidebar-panel__name">{{ item.title }}</span>
                            <span class="course-sidebar-panel__count">
                                {{ item.lessonQtyRead != null ? item.lessonQtyRead : 0 }} /
                                {{ item.lessons?.length ?? 0 }}
                            </span>
                        </div>
                    </v-expansion-panel-title>

                    <v-expansion-panel-text
                        v-for="(lesson, i) in item.lessons"
                        :key="lesson.id || i"
                        class="course-sidebar-lesson-wrap"
                        :class="{
                            'course-sidebar-lesson-wrap--active': lesson.id == idLessonPortal,
                        }"
                    >
                        <button
                            type="button"
                            class="course-sidebar-lesson"
                            :class="{
                                'course-sidebar-lesson--active': lesson.id == idLessonPortal,
                            }"
                            @click="
                                setCurrentLesson(
                                    lesson.id,
                                    i,
                                    lesson.type,
                                    index,
                                    lesson.title,
                                    lesson
                                )
                            "
                        >
                            <span class="course-sidebar-lesson__icon" aria-hidden="true">
                                <svg
                                    v-if="isLessonConcluida(lesson)"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 512 512"
                                    class="course-sidebar-lesson__svg course-sidebar-lesson__svg--done"
                                >
                                    <path
                                        d="M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L369 209z"
                                    />
                                </svg>
                                <svg
                                    v-else
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 512 512"
                                    class="course-sidebar-lesson__svg course-sidebar-lesson__svg--todo"
                                >
                                    <path
                                        d="M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM188.3 147.1c7.6-4.2 16.8-4.1 24.3 .5l144 88c7.1 4.4 11.5 12.1 11.5 20.5s-4.4 16.1-11.5 20.5l-144 88c-7.4 4.5-16.7 4.7-24.3 .5s-12.3-12.2-12.3-20.9l0-176c0-8.7 4.7-16.7 12.3-20.9z"
                                    />
                                </svg>
                            </span>
                            <span class="course-sidebar-lesson__text">
                                <span class="course-sidebar-lesson__name">{{ lesson.title }}</span>
                                <span
                                    v-if="lessonTypeLabel(lesson.type)"
                                    class="course-sidebar-lesson__type"
                                >
                                    {{ lessonTypeLabel(lesson.type) }}
                                </span>
                            </span>
                        </button>
                    </v-expansion-panel-text>
                </v-expansion-panel>
            </v-expansion-panels>
        </div>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import apiCourse from '@/utils/portal/course.js';

export default {
    data() {
        return {
            activePanel: 0,
            currentIndex: 0,
            nameCourse: 'Curso de Teste',
            currentModuleOpenLocal: 0,
            largura: window.innerWidth,
            progress: 0,
            openedLessons: [],
        };
    },
    computed: {
        ...mapState([
            'token',
            'currentLesson',
            'currentModuleOpen',
            'idLessonPortal',
            'nameCurrentLesson',
            'currentCoursePortal',
            'porcetageProgressCurrentCourse',
            'typeLessonPortal',
            'showSidebar',
            'dark',
        ]),
        progressPercentUi() {
            const raw = this.porcetageProgressCurrentCourse;
            const n = typeof raw === 'number' ? raw : parseFloat(raw);
            if (Number.isNaN(n)) {
                return 0;
            }
            return Math.min(100, Math.max(0, Math.round(n)));
        },
    },
    watch: {
        activeModule: {
            handler(val) {
                if (val != null) {
                    this.activePanel = val;
                }
            },
            immediate: true,
        },
        currentModuleOpen: {
            handler(val) {
                if (val != null) {
                    this.currentModuleOpenLocal = val;
                }
            },
            immediate: true,
        },
        data: {
            handler(newModules) {
                if (newModules && newModules.length > 0) {
                    this.getCourseProgressFromAPI();
                }
            },
            immediate: true,
            deep: true,
        },
    },
    props: {
        data: Array,
        currentLesson: String,
        activeModule: Number,
    },
    methods: {
        ...mapActions([
            'storeTypeLessonPortal',
            'storeIdLessonPortal',
            'storeCurrentModuleOpen',
            'storeCurrentLesson',
            'storeNameCurrentLesson',
            'storeShowSidebar',
            'storePorcetageProgressCurrentCourse',
        ]),

        lessonTypeLabel(type) {
            const t = Number(type);
            if (t === 4) return 'PDF';
            if (t === 5) return 'Questionário';
            if (t === 1 || t === 2 || t === 3) return 'Vídeo';
            return '';
        },

        async getCourseProgressFromAPI() {
            try {
                if (
                    this.currentCoursePortal &&
                    this.currentCoursePortal.course &&
                    this.currentCoursePortal.course.id
                ) {
                    const courseResponse = await apiCourse.getDataCourse(
                        this.token,
                        this.currentCoursePortal.course.id
                    );
                    if (courseResponse && courseResponse.progress != null) {
                        this.storePorcetageProgressCurrentCourse({
                            porcetageProgressCurrentCourse: courseResponse.progress,
                        });
                    }
                }
            } catch (error) {
                console.error('Erro ao carregar progresso do curso:', error);
            }
        },

        setPorcetageProgressCurrentCourse(porcetageProgressCurrentCourse) {
            if (
                porcetageProgressCurrentCourse != 0 &&
                porcetageProgressCurrentCourse != null
            ) {
                this.storePorcetageProgressCurrentCourse({
                    porcetageProgressCurrentCourse,
                });
            }
        },

        setCurrentLesson(id, indexLesson, type, index, name, lesson) {
            if (!this.openedLessons.includes(id)) {
                this.openedLessons.push(id);
            }

            this.storeIdLessonPortal({ idLessonPortal: id });
            this.storeCurrentLesson({ currentLesson: indexLesson });
            this.storeTypeLessonPortal({ typeLessonPortal: type });
            this.storeCurrentModuleOpen({ currentModuleOpen: index });
            this.storeNameCurrentLesson({ nameCurrentLesson: name });
            this.storeCurrentLesson({ currentLesson: lesson });
            const largura = window.innerWidth;
            if (largura < 768) {
                this.storeShowSidebar({ showSidebar: false });
            }
        },

        backPage() {
            this.$router.push('/aluno/dashboard');
        },

        isLessonConcluida(lesson) {
            if (lesson.id == this.idLessonPortal) {
                return true;
            }
            if (this.openedLessons.includes(lesson.id)) {
                return true;
            }
            return lesson.progress == 1;
        },
    },
    created() {
        if (this.activeModule != null) {
            this.activePanel = this.activeModule;
        } else {
            this.activePanel = 0;
        }
        if (this.currentModuleOpen != null) {
            this.currentModuleOpenLocal = this.currentModuleOpen;
        }
    },
    async mounted() {
        await this.getCourseProgressFromAPI();
    },
};
</script>

<style>
.v-expansion-panel-text__wrapper {
    padding: 0 !important;
    flex: 1 1 auto;
    max-width: 100%;
}

.course-sidebar-panels .v-expansion-panel-text {
    padding: 0 !important;
}

.global_content_course.dark .course-sidebar-lesson-wrap {
    background-color: #14131a;
}

.global_content_course.dark .course-sidebar-lesson-wrap--active {
    background-color: rgba(25, 199, 208, 0.08);
}
</style>

<style scoped>
.course-sidebar {
    --cs-bg: #f8fafc;
    --cs-surface: #ffffff;
    --cs-border: rgba(15, 23, 42, 0.08);
    --cs-text: #0f172a;
    --cs-muted: #64748b;
    --cs-accent: #19c7d0;
    --cs-accent-soft: rgba(25, 199, 208, 0.12);
    --cs-module-bg: #f1f5f9;
    --cs-scroll: #e2e8f0;

    background-color: var(--cs-surface);
    height: 100%;
    display: flex;
    flex-direction: column;
    border-right: 1px solid var(--cs-border);
}

.course-sidebar--dark {
    --cs-bg: #0f0e12;
    --cs-surface: #14131a;
    --cs-border: rgba(255, 255, 255, 0.08);
    --cs-text: #f1f5f9;
    --cs-muted: #94a3b8;
    --cs-module-bg: #1e1d24;
    --cs-scroll: #334155;
}

.course-sidebar__header {
    flex-shrink: 0;
    padding-bottom: 4px;
    border-bottom: 1px solid var(--cs-border);
    background: var(--cs-bg);
}

.course-sidebar__toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 16px 16px 12px;
}

.course-sidebar__back {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 8px 12px;
    margin: 0;
    border: none;
    border-radius: 10px;
    background: transparent;
    color: var(--cs-muted);
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: color 0.2s, background 0.2s;
    font-family: inherit;
}

.course-sidebar__back:hover {
    color: var(--cs-accent);
    background: var(--cs-accent-soft);
}

.course-sidebar__back-icon {
    transition: transform 0.2s ease;
}

.course-sidebar__back:hover .course-sidebar__back-icon {
    transform: translateX(-3px);
}

.course-sidebar__close {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    padding: 0;
    border: none;
    border-radius: 10px;
    background: var(--cs-module-bg);
    color: var(--cs-text);
    cursor: pointer;
    transition: background 0.2s;
}

.course-sidebar__close:hover {
    background: var(--cs-accent-soft);
    color: var(--cs-accent);
}

.course-sidebar__course {
    padding: 0 16px 18px;
}

.course-sidebar__title {
    margin: 0 0 14px;
    font-size: 15px;
    font-weight: 700;
    line-height: 1.4;
    letter-spacing: -0.02em;
    color: var(--cs-text);
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
}

.course-sidebar__progress {
    display: flex;
    align-items: center;
    gap: 10px;
    width: 100%;
}

.course-sidebar__progress-track {
    flex: 1;
    height: 8px;
    border-radius: 999px;
    background: #e2e8f0;
    overflow: hidden;
    position: relative;
}

.course-sidebar--dark .course-sidebar__progress-track {
    background: #2d2d38;
}

.course-sidebar__progress-fill {
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    border-radius: 999px;
    background: linear-gradient(90deg, #14b8a6, var(--cs-accent));
    transition: width 0.35s cubic-bezier(0.4, 0, 0.2, 1);
    min-width: 0;
}

.course-sidebar__progress-label {
    font-size: 13px;
    font-weight: 700;
    font-variant-numeric: tabular-nums;
    color: #0d9488;
    min-width: 2.75rem;
    text-align: right;
}

.course-sidebar--dark .course-sidebar__progress-label {
    color: #2dd4bf;
}

.course-sidebar__scroll {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    padding: 12px 12px 20px;
}

.course-sidebar__scroll::-webkit-scrollbar {
    width: 6px;
}
.course-sidebar__scroll::-webkit-scrollbar-track {
    background: transparent;
}
.course-sidebar__scroll::-webkit-scrollbar-thumb {
    background: var(--cs-scroll);
    border-radius: 6px;
}

/* Painéis Vuetify */
:deep(.course-sidebar-panels) {
    gap: 10px;
    display: flex;
    flex-direction: column;
}

:deep(.course-sidebar-panel) {
    border-radius: 12px !important;
    overflow: hidden;
    border: 1px solid var(--cs-border) !important;
    background: var(--cs-module-bg) !important;
    box-shadow: none !important;
}

:deep(.course-sidebar-panel::before) {
    display: none;
}

:deep(.course-sidebar-panel__title) {
    padding: 14px 14px !important;
    min-height: auto !important;
    background: transparent !important;
    font-weight: 600 !important;
}

:deep(.course-sidebar-panel__title .v-expansion-panel-title__overlay) {
    border-radius: 12px;
}

:deep(.course-sidebar-panel .v-expansion-panel-title--active) {
    background: rgba(25, 199, 208, 0.08) !important;
}

.course-sidebar-panel__head {
    width: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 10px;
    text-align: left;
}

.course-sidebar-panel__name {
    font-size: 14px;
    font-weight: 600;
    color: var(--cs-text);
    line-height: 1.35;
    flex: 1;
    min-width: 0;
}

.course-sidebar-panel__count {
    flex-shrink: 0;
    font-size: 11px;
    font-weight: 600;
    font-variant-numeric: tabular-nums;
    color: var(--cs-muted);
    background: var(--cs-surface);
    padding: 4px 10px;
    border-radius: 999px;
    border: 1px solid var(--cs-border);
}

.course-sidebar--dark .course-sidebar-panel__count {
    background: #25242c;
}

.course-sidebar-lesson-wrap {
    background: var(--cs-surface);
    border-top: 1px solid var(--cs-border);
    padding: 0 !important;
}

.course-sidebar-lesson {
    width: 100%;
    display: flex;
    align-items: flex-start;
    gap: 12px;
    padding: 12px 14px;
    margin: 0;
    border: none;
    background: transparent;
    cursor: pointer;
    text-align: left;
    font-family: inherit;
    transition: background 0.15s ease;
}

.course-sidebar-lesson:hover {
    background: var(--cs-accent-soft);
}

.course-sidebar-lesson--active {
    background: rgba(16, 185, 129, 0.1);
    box-shadow: inset 3px 0 0 0 #19c7d0;
}

.course-sidebar--dark .course-sidebar-lesson--active {
    background: rgba(25, 199, 208, 0.12);
}

.course-sidebar-lesson__icon {
    flex-shrink: 0;
    width: 28px;
    height: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.course-sidebar-lesson__svg {
    width: 22px;
    height: 22px;
}

.course-sidebar-lesson__svg--done {
    fill: #22c55e;
}

.course-sidebar-lesson__svg--todo {
    fill: #94a3b8;
}

.course-sidebar--dark .course-sidebar-lesson__svg--todo {
    fill: #64748b;
}

.course-sidebar-lesson__text {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.course-sidebar-lesson__name {
    font-size: 13px;
    font-weight: 500;
    color: var(--cs-text);
    line-height: 1.45;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
}

.course-sidebar-lesson__type {
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    color: var(--cs-muted);
}

</style>
